<template>
  <div class="spinner-border text-muted" role="status">
    <span class="visually-hidden">Vent...</span>
  </div>
</template>
